// Parking tax invoices: the shared invoice-generator core with the parking config (audit DUP-21 - invoiceKinds.js).
import React from 'react';
import KindInvoiceGenerator from './KindInvoiceGenerator';
import { INVOICE_KINDS } from './invoiceKinds';

export default function ParkingGenerator() {
    return <KindInvoiceGenerator kind={INVOICE_KINDS.parking} />;
}
